import { ChevronUpIcon } from "@heroicons/react/24/outline";
import cn from "classnames";

interface Props {
  count: number;
  voted: boolean;
  onToggle: () => void;
  busy?: boolean;
  size?: "sm" | "md";
  className?: string;
}

// Canny-style upvote pill: chevron over the count. Stops propagation so it
// works inside clickable cards. Voted state uses the app's selected-blue.
const VoteButton: React.FC<Props> = ({ count, voted, onToggle, busy, size = "md", className }) => (
  <button
    type="button"
    disabled={busy}
    aria-pressed={voted}
    title={voted ? "Remove your vote" : "Upvote"}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      onToggle();
    }}
    className={cn(
      "flex flex-col items-center justify-center rounded-lg border tabular-nums font-semibold transition-colors shrink-0 select-none",
      size === "md" ? "w-12 py-1.5 text-sm" : "w-10 py-1 text-xs",
      voted
        ? "border-blue-300 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/60"
        : "border-base-300 bg-base-100 text-base-content/60 hover:border-blue-300 dark:hover:border-blue-800 hover:text-blue-600 dark:hover:text-blue-300",
      busy && "opacity-60",
      className
    )}
  >
    <ChevronUpIcon className={cn(size === "md" ? "size-4" : "size-3.5", "stroke-[2.5]")} />
    {count}
  </button>
);

export default VoteButton;
